module.exports = __webpack_public_path__ + "img/default.a2aabeaf.png";